import {http, onSuccess, onFail} from './http';

export const watchLandingPresentationRequest = (data) =>
    http.post(`/broadcast/api/watchLanding/presentationRequest`, data)
        .then(onSuccess, onFail);

export const watchLandingBannerClick = (data) =>
    http.post(`/broadcast/api/watchLanding/bannerClick`, data)
        .then(onSuccess, onFail);
